<template>
  <div class="dropdown is-right" :class="{ 'is-active': showDropdown }" style="display:inline-block; margin-left: 10px;">
    <div class="dropdown-trigger">
      <button class="button is-info" @click="showDropdown = !showDropdown">
        <span>{{ $t('forwarders.downloadAgent') }}</span>
        <span class="icon is-small">
          <i class="fas fa-angle-down" aria-hidden="true"></i>
        </span>
      </button>
    </div>
    <div class="dropdown-menu" role="menu">
      <div class="dropdown-content">
        <!-- Use native anchor with download attribute - bypasses Vue Router -->
        <a 
          class="dropdown-item" 
          :href="getDownloadUrl('exe')" 
          @click="showDropdown = false"
        >Window</a>
        <a 
          class="dropdown-item" 
          :href="getDownloadUrl('rpm')" 
          download="agent-setup.rpm"
          @click="showDropdown = false"
        >RPM</a>
        <a 
          class="dropdown-item" 
          :href="getDownloadUrl('deb')" 
          download="agent-setup.deb"
          @click="showDropdown = false"
        >DEB</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgentDownloadDropdown',
  data() {
    return {
      showDropdown: false
    }
  },
  methods: {
    /**
     * Get download URL for agent setup file
     * @param {string} type - Agent type (msi, rpm, deb)
     * @returns {string} Download URL
     */
    getDownloadUrl(type) {
      return `/public/api/v1/agents/download/setup?type=${encodeURIComponent(type)}`
    }
  }
}
</script>
